import React, { useState } from 'react';
import { Container, Row, Col, Card, CardBody, Label, Input, Button, Spinner, CardHeader } from 'reactstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import { useNavigate } from 'react-router-dom';

const AddTemplate = () => {
    const [loader, setLoader] = useState(false);
    const [title, setTitle] = useState('');
    const [notificationType, setNotificationType] = useState('');
    const [notificationSubType, setNotificationSubType] = useState('');
    const [content, setContent] = useState('');
    const [subject, setSubject] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const handleContentChange = (event, editor) => {
        const data = editor.getData();
        setContent(data);
    };

    const validate = () => {
        const errors = {};
        if (!title) errors.title = "Title is required";
        if (!notificationType || !["email", "sms"].includes(notificationType)) {
            errors.notificationType = "Notification type must be 'email' or 'sms'";
        }
        if (notificationType === "email" && !subject) {
            errors.subject = "Subject is required for email notifications";
        }
        if (!notificationSubType || !["login", "sign_up", "appointment"].includes(notificationSubType)) {
            errors.notificationSubType = "Sub Type must be 'login', 'sign_up', or 'appointment'";
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setLoader(true);

        try {
            const payload = {
                title,
                notificationType,
                notificationSubType,
                content,
                subject
            };

            const response = await ApiClient.post('api/users/add-templates', payload);

            toast.success("Template added successfully!", { autoClose: 3000 });
            navigate('/admin/template/list');

        } catch (error) {
            toast.error(error.message, { autoClose: 3000 });
        } finally {
            setLoader(false);
        }
    };

    return (
        <div className="content">
            <Container>
                <Card>
                    <CardHeader>
                        <Button color="primary" onClick={() => navigate("/admin/template/list")}>
                            Back
                        </Button>
                    </CardHeader>
                    <CardBody>
                        <form onSubmit={handleSubmit}>
                            <Row className="mt-3">
                                <Col md="6">
                                    <Label for="title">Title:</Label>
                                    <Input
                                        type="text"
                                        id="title"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                    {errors.title && <div className="error-message">{errors.title}</div>}
                                </Col>
                                <Col md="6">
                                    <Label for="notificationType">Notification Type:</Label>
                                    <Input
                                        type="select"
                                        id="notificationType"
                                        value={notificationType}
                                        onChange={(e) => setNotificationType(e.target.value)}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="email">Email</option>
                                        <option value="sms">SMS</option>
                                    </Input>
                                    {errors.notificationType && <div className="error-message">{errors.notificationType}</div>}
                                </Col>
                                <Col md="6">
                                    <Label for="notificationSubType">Sub Type:</Label>
                                    <Input
                                        type="select"
                                        id="notificationSubType"
                                        value={notificationSubType}
                                        onChange={(e) => setNotificationSubType(e.target.value)}
                                    >
                                        <option value="">Select Sub Type</option>
                                        <option value="login">Login</option>
                                        <option value="sign_up">Sign Up</option>
                                        <option value="appointment">Appointment</option>
                                    </Input>
                                    {errors.notificationSubType && <div className="error-message">{errors.notificationSubType}</div>}
                                </Col>
                                {notificationType === "email" && (
                                    <Col md="6">
                                        <Label for="subject">Subject:</Label>
                                        <Input
                                            type="text"
                                            id="subject"
                                            value={subject}
                                            onChange={(e) => setSubject(e.target.value)}
                                        />
                                        {errors.subject && <div className="error-message">{errors.subject}</div>}
                                    </Col>
                                )}
                            </Row>
                            <Row className="mt-3">
                                <Col md="12">
                                    <Label for="content">Content:</Label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={content}
                                        onChange={handleContentChange}
                                        config={{
                                            toolbar: ['heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo']
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Button type="submit" color="secondary" className="mt-4">
                                Submit {loader && <Spinner size="sm" className="ml-2" />}
                            </Button>
                        </form>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default AddTemplate;
